import { atom, atomFamily, selector, selectorFamily } from "recoil";
import { Products } from "../components/WebSiteApp/Products/Products";
import { computeProductPrice } from "../prices/computeProductPrice";
import tvaList from "../components/WebSiteApp/Subscription/components/tvaList";
import { roundToCents } from "../components/WebSiteApp/Utilitaires";
import {
  buildMonthlySchedule,
  applyGlobalDeductionFromEnd,
  applyTVAToMonthlySchedule,
} from "../prices/computeInvoices";

//url

export const routesState = atom({
  key: "routesState",
  default: [
    "/",
    "/admin",
    "/admin/dashboard",
    // Nouvelles routes par niveau
    "/maternelle",
    "/primaire",
    "/college",
    "/lycee",
    "/cursus-classique/maternelle",
    "/cursus-classique/primaire",
    "/cursus-classique/primaire/cp",
    "/cursus-classique/primaire/ce1",
    "/cursus-classique/primaire/ce2",
    "/cursus-classique/primaire/cm1",
    "/cursus-classique/primaire/cm2",
    "/cursus-classique/college",
    "/cursus-classique/college/sixieme",
    "/cursus-classique/college/cinquieme",
    "/cursus-classique/college/quatrieme",
    "/cursus-classique/college/troisieme",
    "/cursus-classique/lycee",
    "/cursus-classique/lycee/seconde",
    "/cursus-classique/lycee/premiere",
    "/cursus-classique/lycee/premiere/generale",
    "/cursus-classique/lycee/premiere/stmg",
    "/cursus-classique/lycee/premiere/st2s",
    "/cursus-classique/lycee/premiere/tronc-commun",
    "/cursus-classique/lycee/terminale",
    "/cursus-classique/lycee/terminale/generale",
    "/cursus-classique/lycee/terminale/stmg",
    "/cursus-classique/lycee/terminale/st2s",
    "/cursus-classique/lycee/terminale/tronc-commun",
    "/double-cursus",
    "/double-cursus/primaire",
    "/double-cursus/primaire/cp",
    "/double-cursus/primaire/ce1",
    "/double-cursus/primaire/ce2",
    "/double-cursus/primaire/cm1",
    "/double-cursus/primaire/cm2",
    "/double-cursus/college",
    "/double-cursus/college/sixieme",
    "/double-cursus/college/cinquieme",
    "/double-cursus/college/quatrieme",
    "/double-cursus/college/troisieme",
    "/double-cursus/lycee",
    "/double-cursus/lycee/seconde",
    "/double-cursus/lycee/premiere/generale",
    "/double-cursus/lycee/premiere/stmg",
    "/double-cursus/lycee/premiere/st2s",
    "/double-cursus/lycee/terminale/generale",
    "/double-cursus/lycee/terminale/stmg",
    "/double-cursus/lycee/terminale/st2s",
    "/cursus-bilingue/primaire",
    "/cursus-bilingue/college",
    "/cursus-bilingue/lycee",
    "/cursus-belge/primaire",
    "/options/projet-sombreval",
    "/options/cybersecurite",
    "/options/projet-sombreval/souscription",
    "/options/cybersecurite/souscription",
    "/options/projet-sombreval/confirmation",
    "/options/cybersecurite/confirmation",
    "/confirmation-envoi",
    "/cursus-pec",
    "/ateliers-recreatifs",
    "/cours-particuliers",
    "/stages-ete",
    "/la-madrassa-authentique/enfants",
    "/la-madrassa-authentique/femmes",
    "/offres",
    "/tarifs",
    "/tarifs-cursus-classique",
    "/tarifs-double-cursus",
    "/tarifs-cursus-bilingue",
    "/tarifs-cursus-belge",
    "/tarifs-cursus-a-la-carte",
    "/tarifs-ateliers-recreatifs",
    "/tarifs-pec",
    "/coin-lecture",
    //remplacer par une fonction génératrice de tous les liens à partir du fichier articles.js
    "/coin-lecture/pourquoi-ecole-privee-en-ligne",
    "/coin-lecture/reussir-brevet-bac-candidat-libre",
    "/coin-lecture/enseigner-maths-autrement-eve",
    "/coin-lecture/expatriation-ecole-islamique-en-ligne",
    "/coin-lecture/professeurs-ecole-musulmane-excellence",
    "/coin-lecture/fonctionnement-classe-virtuelle",
    "/coin-lecture/enseignement-francais-ecole-privee-musulmane",
    "/coin-lecture/coeducation-ecole-musulmane-en-ligne",
    "/coin-lecture/instruction-famille-monde",
    "/calendrier-scolaire",
    "/temoignages",
    "/faq",
    "/qui-sommes-nous",
    "/mot-de-la-directrice",
    "/conseiller-orientation",
    "/recrutement",
    "/contact",
    "/checkout",
    "/documents/Politique-de-confidentialité-21-22.pdf",
    "/documents/volume-horaire-primaire-classique.pdf",
    "/documents/volume-horaire-college-classique.pdf",
    "/documents/niveaux_cursus_bilingue.pdf",
    "/documents/niveaux_CECRL.pdf",
    "/documents/taux_TVA_Union_Européenne.pdf",
    "/documents/presentation-specialites.pdf",
    "/verification-email",
    "/register",
    "/mon-espace",
    "/ecole-musulmane-en-france",
    "/ecole-privee-musulmane-prix",
    "/404",
  ],
});

//production ou développement
export const isProduction = import.meta.env.PROD;
export const isDevelopment = import.meta.env.DEV;

//année actuelle et années scolaires actuelle et précédente ///////////////////////////////////////////////////////////////////////////

export const thisYearState = atom({
  key: "thisYearState",
  default: new Date().getFullYear(),
});

export const nextYearState = atom({
  key: "nextYearState",
  default: new Date().getFullYear() + 1,
});

function calculSchoolYears() {
  let currentSchoolYear;
  let previousSchoolYear;
  const date = new Date();
  const thisYear = date.getFullYear();
  const FebruaryFirstOfThisYear = new Date(thisYear, 1, 1, 0, 0, 0); //année, mois(0-indexé), jour, heure, min, sec
  if (date >= FebruaryFirstOfThisYear) {
    currentSchoolYear = `${thisYear}-${thisYear + 1}`;
    previousSchoolYear = `${thisYear - 1}-${thisYear}`;
  } else {
    currentSchoolYear = `${thisYear - 1}-${thisYear}`;
    previousSchoolYear = `${thisYear - 2}-${thisYear - 1}`;
  }
  return {
    currentYear: thisYear,
    currentSchoolYear: currentSchoolYear,
    previousSchoolYear: previousSchoolYear,
  };
}
const schoolYears = calculSchoolYears();
export const currentYearState = atom({
  key: "currentYearState",
  default: schoolYears.currentYear,
});

export const currentSchoolYearState = atom({
  key: "currentSchoolYearState",
  default: schoolYears.currentSchoolYear,
});

export const previousSchoolYearState = atom({
  key: "previousSchoolYearState",
  default: schoolYears.previousSchoolYear,
});

// PRODUITS  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//tous les produits
export const productsState = atom({
  key: "productsState",
  default: Products,
});

//light : produits dont le formulaire d'inscription est minimal
export const lightProductsSelector = selector({
  key: "lightProductsSelector",
  get: ({ get }) => {
    const products = get(productsState);
    const lightProductsName = [
      "Cours exclusifs - Primaire/collège",
      "Cours exclusifs - Lycée",
      "Cours exclusifs - Université",
      "Cours exclusifs - Coran",
      "Cours exclusifs - Sciences religieuses",
      "Stage essentiel",
      "Stage bénéfique",
      "Stage de langues",
      "Ateliers de langues",
      "Ateliers scientifiques",
      "Ateliers d'éloquence",
    ];
    //products est un array d'objets
    let array = products.filter((obj) => {
      return lightProductsName.includes(obj["name"]);
    });
    return array;
  },
});

//full : produits dont le formulaire d'inscription contient tous les champs possibles (complet)
export const fullProductsSelector = selector({
  key: "fullProductsSelector",
  get: ({ get }) => {
    const products = get(productsState);
    const fullProductsCursus = ["classique", "double", "bilingue", "belge"];
    //products est un array d'objets
    let array = products.filter((obj) => {
      return fullProductsCursus.includes(obj["cursus"]);
    });
    return array;
  },
});

//half : produits dont le formulaire d'inscription est semi-complet
export const halfProductsSelector = selector({
  key: "halfProductsSelector",
  get: ({ get }) => {
    const products = get(productsState);
    const fullProducts = get(fullProductsSelector);
    const lightProducts = get(lightProductsSelector);
    let array = products.filter((obj) => {
      return !fullProducts.includes(obj) && !lightProducts.includes(obj);
    });
    return array;
  },
});

//type du produit : light, full ou half ?
export const productTypeSelector = selector({
  key: "productTypeSelector",
  get:
    (product) =>
    ({ get }) => {
      const fullProducts = get(fullProductsSelector);
      const lightProducts = get(lightProductsSelector);
      if (lightProducts.includes(product)) {
        return "lightProduct";
      } else if (fullProducts.includes(product)) {
        return "fullProduct";
      } else {
        return "halfProduct";
      }
    },
});

//produits triés selon le cursus en paramètre (pour les cartes qui apparaissent dans la page tarif)
export const productsSelector = selectorFamily({
  key: "productsSelector",
  get:
    (cursus) =>
    ({ get }) =>
      get(productsState).filter((product) =>
        cursus === "classique"
          ? product.cursus === cursus || product.name === "Tronc Commun" //cursus classique + TC
          : product.cursus === cursus,
      ),
});

//produits triés selon la category en paramètre (pour les cartes tarifs qui apparaissent dans les pages produits)
export const productsSelectorByCategory = selectorFamily({
  key: "productsSelectorByCategory",
  get:
    (category) =>
    ({ get }) =>
      get(productsState).filter((product) => product.category === category),
});

//produits triés selon la section en paramètre (pour les cartes tarifs qui apparaissent dans les pages produits)
export const productsSelectorBySection = selectorFamily({
  key: "productsSelectorBySection",
  get:
    (section) =>
    ({ get }) =>
      get(productsState).filter((product) => product.section === section),
});

// PANIER /////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const cartProductsNumberSelector = selector({
  key: "cartProductsNumber",
  get: ({ get }) => {
    let state = get(cartProductsState);

    return state.length;
  },
});

//calcule le total du panier - old
/*export const totalProductsPriceSelector = selector({
  key: "cartProductsTotalPriceSelector",
  get: ({ get }) => {
    let productsCart = get(cartProductsState);

    if (productsCart.length !== 0) {
      let totalProductsPrice = 0;

      productsCart.forEach((product) => {
        //product.price = une portion du versement adpatée au cursus et au mode de paiement
        //ex : cursus classique - classe 5eme - paiement par mois : product.price = 144
        //ex : cursus classique - classe 5eme - paiement par trimestre : product.price = 456
        //ainsi, totalPrice calcule la somme des portions du produit
        let totalPrice =
          product.formData.paymentMethod === "month"
            ? parseFloat(product.price) * 10
            : product.formData.paymentMethod === "trimester"
              ? parseFloat(product.price) * 3
              : product.formData.paymentMethod === "year"
                ? parseFloat(product.price)
                : product.formData.paymentMethod === "once"
                  ? parseFloat(product.price)
                  : product.formData.paymentMethod === "twice"
                    ? parseFloat(product.price) * 2
                    : product.formData.paymentMethod === "thrice"
                      ? parseFloat(product.price) * 3
                      : product.name.includes("Cours exclusifs")
                        ? parseFloat(product.price) *
                          parseFloat(product.formData.nbHours) *
                          4
                        : parseFloat(product.price);

        //ajout du coût de l'option lv3 si le produit en est doté
        if (product.formData.lv3 !== "") {
          let optionCost = product.formData.lv3 === "arabe" ? 351 : 300;
          totalPrice += optionCost;
        }

        totalProductsPrice = totalProductsPrice + totalPrice;
      });

      return totalProductsPrice;
    }
    return 0;
  },
});*/

export const deleteProductCartSelector = selectorFamily({
  key: "deleteProductCartSelector",
  get:
    () =>
    ({ get }) =>
      get(cartProductsState),
  set:
    (productId) =>
    ({ set, get }) => {
      let prevState = get(cartProductsState);
      let newState =
        Array.isArray(prevState) &&
        prevState.filter((product) => product.id !== productId);
      newState !== undefined && set(cartProductsState, newState);
    },
});

export const deleteAlertState = atom({
  key: "deleteAlertState",
  default: [false, null],
});

export const deleteAlertSelector = selector({
  key: "deleteAlertSelector",
  get: ({ get }) => get(deleteAlertState),
  set: ({ set }, newState) => set(deleteAlertState, newState),
});

export const promotionState = atom({
  key: "promotionState",
  default: null,
});

export const promotionSelector = selector({
  key: "promotionSelector",
  get: ({ get }) => get(promotionState),
  set: ({ set }, promotion) => set(promotionState, promotion),
});

//inscriptions purchase state management

/*export const inscriptionPurchaseState = atom({
  key: "inscriptionPurchaseState",
  default: null,
});

export const inscriptionPurchaseSelector = selector({
  key: "inscriptionPurchaseSelector",
  get: ({ get }) => get(inscriptionPurchaseState),
  set: ({ set }, purchase) => {
    set(inscriptionPurchaseState, purchase);
  },
});*/

// subscription form state management

export const formParentState = atomFamily({
  key: "formParentState",
  default: {
    parentStatut: "",
    otherParentStatut: "",
    parentLastname: "",
    parentFirstname: "",
    parentNationality: "",
    parentProfession: "",
    parentAddress: "",
    parentCity: "",
    parentCountry: "",
    parentEmail: "",
    parentPhone: "",
    parentWhatsapp: "",
    parentFacebook: "",
  },
});

export const formChildState = atomFamily({
  key: "formChildState",
  default: {},
});

export const formDataState = atom({
  key: "formDataState",
  default: { childs: [], parents: [] },
});

export const childDataSelector = selectorFamily({
  key: "childDataSelector",
  get:
    (id) =>
    ({ get }) => {
      return get(formDataState).childs[id];
    },
  set:
    (id) =>
    ({ set, get }, newValue) => {
      let state = get(formDataState).childs;
      set({
        ...state,
        [id]: { ...state[id], [newValue.name]: newValue.value },
      });
    },
});

// toggle modal of products cart

export const openProducstCartModal = atom({
  key: "openProducstCartModal",
  default: false,
});

export const openProducstCartModalSelector = selector({
  key: "openProducstCartModalSelector",
  get: ({ get }) => get(openProducstCartModal),
  set: ({ set }, newValue) => {
    set(openProducstCartModal, newValue);
  },
});

// toggle modal of products cart

export const openReturnToFormModal = atom({
  key: "openReturnToFormModal",
  default: false,
});

export const openReturnToFormSelector = selector({
  key: "openReturnToFormSelector",
  get: ({ get }) => get(openReturnToFormModal),
  set: ({ set }, newValue) => {
    set(openReturnToFormModal, newValue);
  },
});

///////////////////////////////////////////////////////////////////////2026//////////////////////////////////////////////////////////////
/////// GESTION PANIER + CODE PROMO/////////////
export const checkoutLockedState = atom({
  key: "checkoutLockedState",
  default: false,
});

export const countryState = atom({
  key: "countryState",
  default: "France",
});

export const tvaRateSelector = selector({
  key: "tvaRateSelector",
  get: ({ get }) =>
    tvaList[get(countryState)] ? tvaList[get(countryState)] : 0,
});

export const cursusState = atom({
  key: "cursusState",
  default: ["classique", "double", "bilingue", "belge"],
});

export const cursusSelector = selector({
  key: "cursusSelector",
  get: ({ get }) => get(cursusState),
});

export const promoCodeState = atom({
  key: "promoCodeState",
  default: "",
});

export const promoCodeSelector = selector({
  key: "promoCodeSelector",
  get: ({ get }) => get(promoCodeState),
});

export const cartProductsState = atom({
  //il s'agit d'un tableau d'objets
  key: "cartProductsState",
  default: localStorage.productsCart
    ? JSON.parse(localStorage.productsCart)
    : [],
});

export const cartProductsSelector = selector({
  key: "cartProductsSelector",
  get: ({ get }) => get(cartProductsState),
  set: ({ set }, newProduct) =>
    set(cartProductsState, (prevState) => [...prevState, newProduct]),
});

export const promotionalProductsSelector = selector({
  key: "promotionalProductsSelector",
  get: ({ get }) => {
    const promoCode = get(promoCodeSelector);
    const productsCart = get(cartProductsSelector);
    const lesCursus = get(cursusSelector);

    let promotionalProducts = [];
    if (promoCode === "FIDELITE26" || promoCode === "CURSUSEVE26") {
      promotionalProducts = productsCart.filter((pdt) =>
        lesCursus.includes(pdt.cursus),
      );
    }
    if (promoCode === "STAGE26") {
      promotionalProducts = productsCart.filter(
        (pdt) => pdt.name === "Stage essentiel" && pdt.price === "150",
      );
    }
    if (promoCode === "JUILLET20") {
      promotionalProducts = productsCart.filter(
        (pdt) =>
          (pdt.cursus === "double" || pdt.cursus === "bilingue") &&
          pdt.formData.paymentMethod === "year",
      );
    }
    return promotionalProducts;
  },
});

//----/

export const cartPricingSelector = selector({
  key: "cartPricingSelector",

  get: ({ get }) => {
    const productsCart = get(cartProductsSelector);
    const quelCodeActif = get(promoCodeSelector);
    const promotionalProducts = get(promotionalProductsSelector);

    let globalTotal = 0;
    let promoDiscountTotal = 0;

    const items = productsCart.map((product) => {
      // prix mensuel de référence
      const initialMonthlyPrice =
        Products.find(
          (p) => p.name === product.name && p.cursus === product.cursus,
        )?.price?.month || 0;

      const isPromotional = promotionalProducts.includes(product);

      const priceInfo = computeProductPrice({
        product,
        quelCodeActif,
        isPromotional,
        initialMonthlyPrice,
      });

      globalTotal += priceInfo.baseTotal;
      promoDiscountTotal += priceInfo.promoDiscount;

      return {
        productId: product.id,
        ...priceInfo, //label, reference, baseTotal, details, promoDiscount, finalTotal, isInstallmentPayment, installment
      };
    });

    return {
      items, // infos prix par produit
      globalTotal: roundToCents(globalTotal), // total brut du panier
      promoDiscountTotal: roundToCents(promoDiscountTotal), // total des remises
    };
  },
});

export const cartTotalsSelector = selector({
  key: "cartTotalsSelector",

  get: ({ get }) => {
    const { items, globalTotal, promoDiscountTotal } = get(cartPricingSelector);

    const productsCart = get(cartProductsSelector);
    const lesCursus = get(cursusSelector);

    // Montant après promo
    const totalAfterPromo = roundToCents(globalTotal - promoDiscountTotal);

    // Nombre de produits "cursus annuel"
    const annualCursusCount = productsCart.filter((pdt) => {
      const info = pdt.formData || pdt.options;
      return lesCursus.includes(pdt.cursus) && info.paymentMethod === "year";
    }).length;

    // Montant réduction famille
    const familyDiscountRate =
      annualCursusCount >= 2 ? annualCursusCount / 100 : 0;
    const familyDiscount = roundToCents(totalAfterPromo * familyDiscountRate);

    //réduction parrainage - TODO

    // Total après promo + famille
    const totalAfterFamilyDiscount = roundToCents(
      totalAfterPromo - familyDiscount,
    );

    return {
      globalTotal,
      promoDiscountTotal,
      totalAfterPromo,

      annualCursusCount,
      familyDiscountRate,
      familyDiscount,

      totalAfterFamilyDiscount,
    };
  },
});

export const cartFinalTotalsSelector = selector({
  key: "cartFinalTotalsSelector",

  get: ({ get }) => {
    const {
      globalTotal,
      promoDiscountTotal,
      totalAfterPromo,
      familyDiscount,
      totalAfterFamilyDiscount,
    } = get(cartTotalsSelector);

    const productsCart = get(cartProductsSelector);
    const tvaRate = get(tvaRateSelector);

    // Frais de dossier = somme des registrationFees
    const registrationFeesTotal = roundToCents(
      productsCart.reduce((sum, product) => {
        const referenceProduct = Products.find(
          (p) => p.name === product.name && p.cursus === product.cursus,
        );

        return sum + (referenceProduct?.registrationFees || 0);
      }, 0),
    );

    // Base TVA
    const tvaBase = roundToCents(
      totalAfterFamilyDiscount + registrationFeesTotal,
    );

    // TVA
    const tvaAmount = roundToCents(tvaBase * tvaRate);

    // Total TTC
    const totalTTC = roundToCents(tvaBase + tvaAmount);

    return {
      // Totaux économiques
      globalTotal,
      promoDiscountTotal,
      totalAfterPromo,
      familyDiscount,
      totalAfterFamilyDiscount,

      // Frais & taxes
      registrationFeesTotal,
      tvaRate,
      tvaAmount,

      // Final
      totalTTC,
    };
  },
});

export const cartPaymentTodaySelector = selector({
  key: "cartPaymentTodaySelector",

  get: ({ get }) => {
    const { items } = get(cartPricingSelector);
    const productsCart = get(cartProductsSelector);
    const { registrationFeesTotal } = get(cartFinalTotalsSelector);
    const tvaRate = get(tvaRateSelector);
    const promoCode = get(promoCodeSelector);

    let fullPaymentTotal = 0;
    let downPaymentTotal = 0;

    const hasZeroImmediateFees = promoCode === "FIDELITE26";

    productsCart.forEach((cartProduct, index) => {
      const item = items[index];

      const referenceProduct = Products.find(
        (p) => p.name === cartProduct.name && p.cursus === cartProduct.cursus,
      );

      const downPayment = referenceProduct?.downPayment || 0;

      if (downPayment > 0) {
        // produit avec acompte
        downPaymentTotal += downPayment;
      } else {
        //premier versement d'un produit payé en plusieurs fois
        if (item.isInstallmentPayment) {
          fullPaymentTotal += item.installment;
        } else {
          // sinon produit payé intégralement
          fullPaymentTotal += item.finalTotal;
        }
      }
    });

    fullPaymentTotal = roundToCents(fullPaymentTotal);
    downPaymentTotal = roundToCents(downPaymentTotal);

    const downPaymentTotalToday = hasZeroImmediateFees ? 0 : downPaymentTotal;

    const registrationFeesTotalToday = hasZeroImmediateFees
      ? 0
      : registrationFeesTotal;

    const immediatPaymentHT = roundToCents(
      fullPaymentTotal + downPaymentTotalToday + registrationFeesTotalToday,
    );

    const tvaToday = roundToCents(tvaRate * immediatPaymentHT);

    const immediatPaymentTTC = roundToCents(immediatPaymentHT + tvaToday);

    return {
      fullPaymentTotal,
      downPaymentTotal,
      downPaymentTotalToday,
      registrationFeesTotal,
      registrationFeesTotalToday,
      immediatPaymentHT,
      tvaToday,
      immediatPaymentTTC,
    };
  },
});

export const shouldShowPaymentTodaySelector = selector({
  key: "shouldShowPaymentTodaySelector",

  get: ({ get }) => {
    const { totalTTC } = get(cartFinalTotalsSelector);
    const { immediatPaymentTTC } = get(cartPaymentTodaySelector);

    // On affiche uniquement s'il y a un reste à payer
    return immediatPaymentTTC < totalTTC;
  },
});

/*export const cartScheduleSelector = selector({
  key: "cartScheduleSelector",

  get: ({ get }) => {
    const productsCart = get(cartProductsSelector);
    const { items: pricingItems } = get(cartPricingSelector);
    const promoCode = get(promoCodeSelector);

    const { promoDiscountTotal, familyDiscount } = get(cartTotalsSelector);

    const { downPaymentTotal } = get(cartPaymentTodaySelector);

    const tvaRate = get(tvaRateSelector);

    // Échéancier mensuel brut HT (avant remises)
    const monthlyHTSchedule = buildMonthlySchedule(
      productsCart,
      pricingItems,
      promoCode,
    );

    // Somme globale à déduire
    const totalToDeduct =
      promoDiscountTotal + familyDiscount + downPaymentTotal;

    // Application de la déduction globale (en remontant)
    const afterDeductionSchedule = applyGlobalDeductionFromEnd(
      monthlyHTSchedule,
      totalToDeduct,
    );

    // Application de la TVA par mois
    const finalSchedule = applyTVAToMonthlySchedule(
      afterDeductionSchedule,
      tvaRate,
    );

    return finalSchedule;
  },
});*/
